import { MovementCarrierPay } from "../../../powerbroker/src/MovementCarrierPay";
import { LbReasonsPanel } from "../LbReasonsPanel";
import { Checkbox, CityState, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPostToLoadBoards extends Layout {
    andLabel: Label;
    checkboxExpedited: Checkbox;
    checkboxTarps: Checkbox;
    layoutCarrierRates: MovementCarrierPay;
    layoutLbReasonsPanel: LbReasonsPanel;
    panelComments: Panel;
    panelDivider: Panel;
    panelEquipTypeOptions: Panel;
    panelMainLbReasons: Panel;
    panelOptions: Panel;
    panelRates: Panel;
    panelScheduling: Panel;
    panelServices: Panel;
    panelUserInfo: Panel;
    postingCityState: CityState;
    sourceCity: DataSource;
    sourceLocation: DataSource;
    sourceOrders: DataSource;
    sourcePbwLoadboardServices: DataSource;
    switchDefaultUser: Switch;
    switchPostToVendors: Switch;
    switchTargetRate: Switch;
    textboxDefaultUserPostingRole: Textbox;
    textboxOverrideArriveEarly: Textbox;
    textboxOverrideArriveLate: Textbox;
    textboxPnnCallback: Textbox;
    textboxPnnComment2: Textbox;
    textboxPnnComment: Textbox;
    textboxPnnLoadboardUserId: Textbox;
    textboxPnnRate: Textbox;
    textboxPnnRateType: Textbox;
    textboxPnnTrailerLength: Textbox;
    textboxPnnTrailerWidth: Textbox;
    textboxVendors: Textbox;
    textboxWeight: Textbox;
}
